module.exports = __webpack_public_path__ + "img/position_WB.1e150161.png";